// Slot bookkeeping for multi-main / multi-PX deals.
//
// A deal's extra products live in two places that must stay in step: the
// parallel state arrays (additionalMain* / px*) and the journey entries that
// carry the slot index. Kept in its own module so it can be tested without
// standing up the whole request hook.

/**
 * Drop every journey entry belonging to one slot, and pull the slots ABOVE it
 * down by one.
 *
 * The re-index is the part that is easy to miss: the section generators size a
 * deal by the HIGHEST slot index they can see (so a slot hydrated on an EDIT
 * deal, which has no journey entry, still renders). Filtering alone would leave
 * the old maximum in place, the slot count inflated by one, and an empty
 * section rendering for a slot whose state array no longer has an entry.
 *
 * `key` is "pxSellIdx" or "mainSlotIdx"; entries where it is null/undefined
 * belong to the primary and pass through untouched.
 */
export function withSlotRemoved(entries, key, removedIdx) {
  return (entries ?? [])
    .filter((entry) => entry?.[key] !== removedIdx)
    .map((entry) => {
      const idx = entry?.[key];
      if (idx === null || idx === undefined || idx <= removedIdx) return entry;
      return { ...entry, [key]: idx - 1 };
    });
}
